module.exports = __webpack_public_path__ + "img/service_350x500_1.067b45e7.jpg";